'use client';

import classNames from 'classnames';
import { FC, ReactNode } from 'react';

import { useEventOnceData } from '@/entities/event';
import {
  EventForm,
  EventHero,
  EventPanel,
  EventTeaList,
} from '@/widgets/events';

import styles from './eventPage.module.scss';

interface EventProps {
  slug: string;
  breadcrumbs?: ReactNode;
}

const FALLBACK_LOCATION = '-';

const EventPage: FC<EventProps> = ({ slug, breadcrumbs }) => {
  const { data: event } = useEventOnceData(slug);
  if (!event) {
    return null;
  }

  const location = event.address.trim() ? event.address : FALLBACK_LOCATION;

  return (
    <main className={classNames('page', styles.eventPage)}>
      <EventHero event={event} />
      <EventPanel event={event} eventSlug={slug} location={location} />
      <div
        dangerouslySetInnerHTML={{ __html: event.text }}
        className={styles.eventPage__content}
      ></div>
      <EventTeaList event={event} />
      <EventForm event={event} />
      <div className="container">{breadcrumbs}</div>
    </main>
  );
};

export default EventPage;
